import { RoleMention, UserMention } from "./initial_mentions_blurb";

export function MentionsList(props: {
	role_mention_ids: string[];
	user_mention_ids: string[];
}) {
	const { role_mention_ids, user_mention_ids } = props;

	return (
		<>
			{role_mention_ids.length === 0 && user_mention_ids.length === 0 && (
				<>None</>
			)}
			{role_mention_ids.map((val) => (
				<RoleMention key={val} id={val} />
			))}
			{user_mention_ids.map((val) => (
				<UserMention key={val} id={val} />
			))}
		</>
	);
}
